export class Environment {
	API_URL = 'http://localhost:5500/api';
	production = false;
	version = require('../../../../package.json').version;
}
